var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.getOrgs,"items-per-page":50,"item-key":"acronym"},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('OrgUpdate',{attrs:{"orgid":item.id}}),_c('v-icon',{on:{"click":function($event){return _vm.delOrganisation(item.id)}}},[_vm._v("mdi-delete")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }